import pdfMake, { userMark, setMyConfig, makeTableContent } from "@/utils/pdf";

function pdfBiblia(pContent) {
  const columns = [
    "fecha:w28",
    "servicio:w*",
    "registros:w30",
    {
      key: "nroAdultos",
      label: "PAX",
      width: 16,
    },
    {
      key: "nroNinos",
      label: "CHD",
      width: 16,
    },
    {
      key: "espanol",
      label: "ESP",
      width: 16,
    },
    {
      key: "ingles",
      label: "ING",
      width: 16,
    },
    {
      key: "pendiente",
      label: "Pen.",
      width: 16,
    },
    {
      key: "confirmado",
      label: "Con.",
      width: 16,
    },
    {
      key: "vehiculo",
      label: "Vehículo.",
      width: "*",
    },
    {
      key: "guia",
      label: "Guía.",
      width: "*",
    },
    "asistente:w*",
    "ordenes:w28",
  ];

  const table = makeTableContent([...pContent.biblias], columns);

  pdfMake
    .createPdf({
      info: {
        title: `Biblia`,
      },
      content: [
        {
          text: "Biblia",
          style: "h1",
        },
        {
          columns: [
            {
              text: `Servicio: ${pContent.servicio}`,
              width: "auto",
            },
            {
              text: `Fecha: ${pContent.fecha}`,
              width: "auto",
            },
            {
              text: `Estado: ${pContent.estado}`,
              width: "auto",
            },
          ],
          margin: [0, 0, 0, 5],
        },
        {
          text: "Resumen",
          style: "header",
        },
        {
          columns: [
            {
              text: `Nro. de Biblias: ${pContent.resumen.nroBiblias}`,
              width: "auto",
            },
            {
              text: `Registros: ${pContent.resumen.registros}`,
              width: "auto",
            },
            {
              text: `Pendientes: ${pContent.resumen.pendientes}`,
              width: "auto",
            },
            {
              text: `P. Total: ${pContent.resumen.pTotal}`,
              width: "auto",
            },
            {
              text: `PAX: ${pContent.resumen.pAdultos}`,
              width: "auto",
            },
            {
              text: `CHD: ${pContent.resumen.pNinos}`,
              width: "auto",
            },
            {
              text: `Español: ${pContent.resumen.espanol}`,
              width: "auto",
            },
            {
              text: `Inglés: ${pContent.resumen.ingles}`,
              width: "auto",
            },
          ],
        },
        {
          text: "",
          margin: [0, 0, 0, 5],
        },
        table,
        ...userMark(pContent.userMark, pContent.dateMark),
      ],
      ...setMyConfig("portrait"),
    })
    .print();
}

export default pdfBiblia;
